import React from 'react'
import PropTypes from 'prop-types'
import { Text, H3 } from 'components/atoms/Typography'
import { COLORS, TEL_NUMBER } from 'config/constants'
import Dialog from 'components/organisms/Dialog'
import Link from 'components/atoms/Link'

const ModalContact = ({ onClose, isModalOpen }) => (
  <Dialog.Narrow
    onClose={onClose}
    onClick={onClose}
    isVisible={isModalOpen}
    buttonLabel="CONTINUE"
    title={<H3 textAlign="center">Thank You For Your Interest!</H3>}
    body={
      <Text.Block textAlign="center">
        <Text fontSize={{ desktop: 'l' }} color={COLORS.LUXURY}>
          Congratulations on becoming one step closer to owning your Dream Home!
          You will be contacted with more information regarding this process. If
          you don't want to wait, you can call us directly at:
        </Text>
        <Link
          href={`tel:${TEL_NUMBER}`}
          fontSize={{ desktop: 'l' }}
          display="block"
        >
          {TEL_NUMBER}
        </Link>
      </Text.Block>
    }
  />
)

ModalContact.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default ModalContact
